import { legacyDestination } from './site-navigation-model.mjs';

export function redirectLegacySection() {
  const routes = window.SKAI?.routes;
  if (!routes) return false;
  const destination = legacyDestination(window.location.href, routes);
  if (!destination) return false;
  window.location.replace(destination);
  return true;
}

export function initContactDraftGuard() {
  const form = document.querySelector('[data-project-enquiry]');
  if (!form) return;
  let changed = false, nativeSubmitting = false;
  const initialSummary = form.querySelector('[data-contact-summary]')?.value || '';
  const hasDraft = () => {
    const contactValues = ['name', 'email', 'company', 'phone', 'message'].some(name => form.elements.namedItem(name)?.value.trim());
    const summary = form.querySelector('[data-contact-summary]')?.value.trim() || '';
    return contactValues || Boolean(summary && summary !== initialSummary.trim());
  };
  const dirty = () => { changed = true; };
  form.addEventListener('input', dirty);
  form.addEventListener('change', dirty);
  // Native submission remains available when fetch or FormData is unavailable.
  form.addEventListener('submit', event => { nativeSubmitting = !event.defaultPrevented; });
  window.addEventListener('beforeunload', event => {
    if (!changed || !hasDraft() || nativeSubmitting || form.dataset.sent === 'true') return;
    event.preventDefault(); event.returnValue = '';
  });
}
